<div app-topbar class="layout-topbar">
	<div class="layout-topbar" style="margin-right: 0px !important">
		<button type="button" class="mobile-menu-toggle" appMobileSidebarToggler aria-label="Toggle menu">
			<i class="pi pi-bars"></i>
		</button>
		<div style="min-width: 200px; height: 100%">
			@if(logo || portale) {
			<a class="app-logo" routerLink="/">
				@if(logo){
				<img style="max-width: 180px; max-height: 60px" alt="app logo" [src]="sanitizer.bypassSecurityTrustResourceUrl(logo)" />
				} @else if(portale) {
				<span class="app-name">{{ portale }}</span> }
			</a>
			}
		</div>

		<div class="header-center" style="flex: 1 1 0; display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 20px; min-width: 0; overflow: hidden">
			@if(menuLayout === 'top') {
			<app-topnav></app-topnav>
			} @else if(active_company_name) {
			<span id="company_selection" class="header-active-company" style="display: flex; align-items: center; gap: 8px; min-width: 0; font-weight: 600; color: var(--kcs-header-text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
				<i class="pi pi-building" aria-hidden="true"></i>
				<span style="overflow: hidden; text-overflow: ellipsis">{{ active_company_name }}</span>
			</span>
			}
		</div>
		<div class="topbar-actions" style="min-width: 200px; display: flex; align-items: center; gap: 12px;">
			<app-export-jobs-panel [companyId]="configService.getCompany_id()"></app-export-jobs-panel>
			<!-- Modifica del menu sul menu stesso: ADMIN di portale, solo desktop -->
			<!-- In modifica la matita resta accesa: un clic esce (con modifiche non salvate chiede conferma in basso) -->
			@if(menuEdit.puoModificare()) {
			<span class="d-none d-lg-inline-flex">
				<button type="button" class="notification-bell menu-edit-toggle" [class.menu-edit-attivo]="menuEdit.attivo()" (click)="menuEdit.attivo() ? menuEdit.chiediUscita() : menuEdit.avvia()" [disabled]="menuEdit.caricamento() || menuEdit.salvataggio()" [pTooltip]="(menuEdit.attivo() ? 'Esci dalla modifica del menu' : 'Modifica menu') | translate" tooltipPosition="bottom" [attr.aria-label]="(menuEdit.attivo() ? 'Esci dalla modifica del menu' : 'Modifica menu') | translate" [attr.aria-pressed]="menuEdit.attivo()">
					<i class="pi pi-pencil" style="font-size: 1.1rem"></i>
				</button>
			</span>
			}
			@if(showChat) {
			<button type="button" class="notification-bell" (click)="chatPanelVisible = true" title="Messaggi">
				<i class="pi pi-comments" style="font-size: 1.2rem; color: var(--kcs-topnav-text, var(--kcs-header-text));"></i>
				@if(unreadMessagesCount > 0) {
				<span class="notification-badge">{{ unreadMessagesCount > 99 ? '99+' : unreadMessagesCount }}</span>
				}
			</button>
			}
			@if(showNotifications) {
			<button type="button" class="notification-bell" (click)="notifPop.toggle($event)" title="Notifiche">
				<i class="pi pi-bell" style="font-size: 1.2rem; color: var(--kcs-topnav-text, var(--kcs-header-text));"></i>
				@if(unreadCount > 0) {
				<span class="notification-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
				}
			</button>
			<p-popover #notifPop class="notif-popover" (onShow)="notifCmp.load()">
				<app-notifications-panel #notifCmp (closed)="notifPop.hide()" (unreadChanged)="loadUnreadCount()"></app-notifications-panel>
			</p-popover>
			}
			<div class="topbar-profile" style="position: relative">
				<button type="button" class="topbar-profile-button" (click)="op.toggle($event)" [class.active]="false">
					<span class="profile-details">
						<span class="profile-name">{{ this.configService.getUser().usr_firstname }} {{ this.configService.getUser().usr_lastname }}</span>
					</span>
					@if(userAvatar) {
					<img [src]="userAvatar" alt="avatar" class="ml-2 user-avatar-img" />
					} @else {
					<p-avatar [label]="configService.getUsernameInitials()" class="ml-2 user-avatar" shape="circle" [style]="{ background: 'var(--kcs-primary)', color: 'var(--kcs-primary-text)' }"> </p-avatar>
					}
				</button>

				<p-popover #op class="header-popover">
					<div class="profile-popover-content" (click)="op.hide()">
						<ul class="nav">
							<li class="nav-item w-full profile-switch" (click)="$event.stopPropagation()">
								<span class="profile-switch-label"><i class="pi pi-building"></i> {{ 'header.azienda' | translate }}</span>
								<div class="d-flex gap-2 align-items-center w-full">
									@if(totalCompanies > 1) {
									<p-select appendTo="body" [options]="sel_companies" (onFilter)="onComapnyFilterChange($event)" [filter]="true" [(ngModel)]="sel_company" optionLabel="name" [placeholder]="active_company_name" panelStyleClass="header-select-panel" (onChange)="selectCompany()" [style]="{ width: '100%' }" styleClass="flex-grow-1"></p-select>
									} @else {
									<span class="profile-switch-value flex-grow-1">{{ active_company_name }}</span>
									}
									<!-- Inserimento di una nuova azienda: riservato agli amministratori -->
									@if(configService.isUserSuperAdmin()) {
									<p-button icon="pi pi-plus" size="small" [rounded]="true" [outlined]="true" severity="secondary" pTooltip="Nuova azienda" (onClick)="op.hide(); nuovaAzienda()"></p-button>
									}
								</div>
							</li>
							@if(active_user_name && configService.isUserSuperAdmin()) {
							<li class="nav-item w-full profile-switch" (click)="$event.stopPropagation()">
								<span class="profile-switch-label"><i class="pi pi-users"></i> User</span>
								@if(totalUsers > 1) {
								<p-select appendTo="body" [options]="sel_users" (onFilter)="onUserFilterChange($event)" [filter]="true" [(ngModel)]="sel_user" optionLabel="usr_username" [placeholder]="active_user_name" panelStyleClass="header-select-panel" (onChange)="selectUser()" [style]="{ width: '100%' }"></p-select>
								} @else {
								<span class="profile-switch-value">{{ active_user_name }}</span>
								}
							</li>
							}
							<!-- Se esiste un admin salvato (impersonificazione attiva) il ripristino deve essere sempre disponibile -->
							@if(currentUserAdmin) {
							<li class="nav-item w-full">
								<a (click)="restoreAdmin()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-undo"></i><span>{{ 'Ripristina Admin' | translate }}</span></a>
							</li>
							}
							@if(currentUser?.usr_mail) {
							<li class="nav-item w-full profile-switch" (click)="$event.stopPropagation()">
								<span class="profile-switch-label"><i class="pi pi-envelope"></i> {{ 'Email' | translate }}</span>
								<span class="profile-switch-value">{{ currentUser.usr_mail }}</span>
							</li>
							}
							<li class="nav-item w-full"><hr class="profile-divider" /></li>
							<li class="nav-item w-full">
								<a (click)="goToProfile()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-user"></i><span>Mio Profilo</span></a>
							</li>
							<li class="nav-item w-full">
								<a (click)="changeLanguage()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-language"></i><span>Cambia Lingua</span></a>
							</li>
							<li class="nav-item w-full">
								<a (click)="changePortal()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-cog"></i><span>Cambia Portale</span></a>
							</li>
							<li class="nav-item w-full">
								<a (click)="signOut()" class="pl-1 nav-link nav-dropdown-toggle"><i class="pi pi-power-off"></i><span>Esci</span></a>
							</li>
						</ul>
					</div>
				</p-popover>
			</div>
		</div>
	</div>
</div>

@if(showChat) {
<app-chat-panel [(visible)]="chatPanelVisible" (unreadChanged)="loadUnreadMessagesCount()"></app-chat-panel>
}

<ng-template #changeLanguageModal>
	<div class="language-selector">
		<div class="flex flex-wrap gap-4">
			<div class="flex items-center">
				<p-radiobutton name="language" value="it" [(ngModel)]="language" inputId="sel_italiano" />
				<label for="sel_italiano" class="ml-2">Italiano</label>
			</div>

			<div class="flex items-center">
				<p-radiobutton name="language" value="en" [(ngModel)]="language" inputId="sel_english" />
				<label for="sel_english" class="ml-2">English</label>
			</div>
		</div>
	</div>
</ng-template>
